import { InternalUserPermission } from '../../../enum/InternalUserPermission'
import useTenantPermissions from './useTenantPermissions'

const usePermission = (key: InternalUserPermission): boolean => {
    const { can } = useTenantPermissions()
    return can(key)
}

export default usePermission
